export default "__VITE_ASSET__a00ff33b__"